import React from 'react'
import { Row, Divider } from 'antd'
import { content } from '../components'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { getOneOrderSelector } from 'src/features'
import styles from './MyOrderListDetailsPageContent.module.scss'
import { CustomCard, CustomTitle, CustomCol } from 'src/components'

const MyOrderListDetailsPageContent: React.FC = () => {
  const { t } = useTranslation()
  const { loading, order, orderItem } = useAppSelector(getOneOrderSelector)
  const isLoading = loading || !order || !orderItem

  const hasFee: boolean = Boolean(
    orderItem?.breakdownFeeBaseAmount ||
    orderItem?.breakdownFeeTaxAmount ||
    orderItem?.fee
  )

  return <CustomCard loading={isLoading}>
    {!isLoading && <>
      <Row>
        <CustomCol className={styles.boxDetails}>
          <content.OrderItemDetails
            order={order}
            orderItem={orderItem}
          />
        </CustomCol>
        <CustomCol>
          <content.OrderItemImage image={orderItem.project_thumbnail} />
        </CustomCol>
      </Row>
      <Divider />
      <Row>
        <CustomCol
          lg={hasFee ? 12 : 24}
          className={styles.left}
        >
          <content.OrderProjectDetails
            order={order}
            orderItem={orderItem}
          />
        </CustomCol>

        {hasFee && (
          <CustomCol className={styles.right}>
            <content.OrderFeeDetails
              order={order}
              orderItem={orderItem}
            />
          </CustomCol>
        )}
      </Row>

      {!orderItem.is_cancelled && <>
        <Divider />
        <CustomTitle label={t('Transactions.Download')} />
        <Row>
          <CustomCol className={styles.left}>
            <content.OrderItemCertificates
              order={order}
              orderItem={orderItem}
            />
          </CustomCol>
          <CustomCol className={styles.right}>
            <content.OrderItemFeeCertificates
              order={order}
              orderItem={orderItem}
            />
          </CustomCol>
        </Row>
      </>}
    </>}
  </CustomCard>
}

export default MyOrderListDetailsPageContent
